(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('cartForm', cartForm);

    /* @ngInject */
    function cartForm($rootScope) {
        var directive = {
            bindToController: true,
            controller: cartFormController,
            templateUrl: 'cart-form.tpl',
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.openedSidebar = false;
            var formSection = scope.vm.data.layout.sections.find(function(e) {
                return e.type.value == 'form';
            });

            scope.vm.formFields = formSection.form.fields;

            scope.vm.tabs = scope.$root.getField(scope.vm.formFields, ['tab']).choices.filter(function(t) {
                return t.value != 'gift' || scope.$root.safeChain(scope.$root.globals.site_options, 'shopping_cart_settings,hide_gift_tab') == "show";
            });

            scope.vm.formSettings = formSection.form.settings;
            scope.vm.formData = formSection.form.data;
            scope.vm.formData.cartPies = {};
            scope.vm.formData.cartGiftPies = [];
            scope.vm.formData.dtRange = '';
            scope.vm.doingRequest = false;
            scope.vm.sidebarOpen = function() {
                scope.vm.openedSidebar = !scope.vm.openedSidebar;
            };
            //angular.element('h5:contains("Select pick-up site")').addAttr
            scope.vm.formData.source = {
                seller: {
                    value: undefined
                }
            };

            if(typeof $rootScope.selectedSeller !== 'undefined') {
                scope.vm.formData.source.seller.value = parseInt($rootScope.selectedSeller);
            }

            if (scope.$root.project_has_opt('giftPie')) {
                if (scope.$root.project_has_opt('separateRedeem')) {
                    var ccf = scope.$root.getField(scope.vm.formFields, ['billing', 'coupon-code']);
                    if (ccf.default) {
                        scope.$root.shoppingCartActiveTab = 'redeem';
                    } else if (window.location.hash && (window.location.hash == '#redeem')) {
                        scope.$root.shoppingCartActiveTab = 'redeem';
                    }
                }

                setTimeout(function() {
                    scope.checkCoupon(true);
                }, 1000);
            }

            if (scope.$root.project_has_opt('reservation')) {
                setTimeout(function() {
                    scope.checkReservation(true);
                }, 1000);
            }

            var activeTab = (angular.isDefined(scope.$root.shoppingCartActiveTab) && (scope.$root.shoppingCartActiveTab != '')) ? scope.$root.shoppingCartActiveTab : 'self';
            // scope.vm.formData.tab = {value: ''};
            scope.setTab(activeTab);
            delete scope.$root.shoppingCartActiveTab;
            // setTimeout(function() {
            //     scope.setTab(activeTab);
            //     delete scope.$root.shoppingCartActiveTab;
            // }, 10);

            if (scope.$root.project_has_opt('siteInventory')) {
                setTimeout(function() {
                    scope.$broadcast('site-inventory-filter', {});
                }, 2000);
            }

            setTimeout(function() {
                angular.element('a.tt').each(function(i, e) {
                    angular.element(e).on('mouseout',function(ee) {
                        angular.element('.tooltip-content').hide();
                    });
                    angular.element(e).on('mouseover click',function(ee) {
                        ee.preventDefault();
                        ee.stopPropagation();
                        var anch = angular.element(this);
                        var tooltipID = anch.prop('class').replace(/\s*tt\s*/, '');
                        var tt = angular.element('.tooltip-content');
                        if (tt.length == 0) {
                            tt = angular.element('<div class="tooltip-content"></div>').appendTo(angular.element('cart-form'));
                        }
                        tt.show();
                        tt.html(scope.$root.tooltips[tooltipID]);
                        var winWidth = angular.element(window).width();
                        var left = winWidth < 768 ? 0 : anch.offset().left + anch.width() + 10;
                        tt.css({
                            top: (anch.offset().top - tt.height()) + 'px',
                            left: left + 'px'
                        });
                    });
                });
                angular.element('cart-form').on('click','.tooltip-content',function(ce) {
                    ce.preventDefault();
                    ce.stopPropagation();
                    if (angular.element(ce.target) != angular.element('.tooltip-content')) {
                        angular.element('.tooltip-content').hide();
                    }
                });
            }, 2000);
            angular.element('cart-form').on('input','input[name="discount_code"]', function() {
                angular.element('input[name="discount_code"]').siblings('ul.error-msg').hide().find('li').hide().text('');
            });

            if (scope.vm.formSettings.accordion.value && scope.$root.project_has_opt('scWizard')) {
                scope.vm.IsWizard = true;
                scope.wizard.init();
            } else {
                scope.vm.IsWizard = false;
            }
        }
    }

    /* @ngInject */
    function cartFormController ($scope, $rootScope,$timeout,$http,$location,$sce, dateFilter, $cookies) {
        // sidebar sticky - start

        var sideEl = $('.sidebar-body');
        $timeout(function() {
            $scope.topPos = sideEl.offset().top;
        });

        $rootScope.$on('throttledScroll', function(e, args) {
            //console.log(['throttled onScroll', e, args]);
            var navH = $('#sticky-nav').height(),
            top = $(document).scrollTop() + navH,
            pip = $('.footer').offset().top - 90,
            height = $('.sidebar-body').outerHeight();
            if (top > $scope.topPos && top < pip - height) {
                sideEl.addClass('sticky').removeClass('bottom').removeAttr("style");
            } else if (top >= pip - height) {
                sideEl.addClass('bottom');
            } else {
                sideEl.removeClass('sticky').removeClass('bottom');
            }
        });

        $scope.vm.sidebarData = {
            sellerName: '',
            pies: {},
            giftPies: [],
            donation: 0,
            orderTotal: 0,
            giftTotal: 0,
            // location: {
            //     range: ''
            // },
            location: null,
            total: 0,
            couponCode: '',
            couponData: {},
            discountData: {},
            discountTotal: 0,
            couponTotal: 0,
            totalCount: 0
        };

        $scope.vm.regularPrice =  $scope.$root.globals.site_options.shopping_cart_settings['pie-price'];
        $scope.vm.giftPrice =  $scope.$root.globals.site_options.shopping_cart_settings.gift_pie_price;
        $scope.vm.piesEditing = false;


        $scope.openFold = function(field) {
            setTimeout(function() {
                $scope.wizard.folds.forEach(function(e) {
                    if (e.name != field.name) {
                        angular.element('[field-key="' + e.name + '"] .accordion-help').addClass('ng-hide');  // important
                        angular.element('[field-key="' + e.name + '"] .group-content-wrap').addClass('ng-hide');  // important
                    }
                    $scope.$root.getField($scope.vm.formFields, [e.name]).expanded = false;
                });
                field.expanded = true;
                $scope.$evalAsync();
            }, 0);
        };

        $scope.$on('accordion-tab', function(e, fk) {
            if ($scope.$root.project_has_opt('creditCardFee')) {
                if (fk == 'billing') {
                    $scope.vm.formData.billing.card_fee = {value: true};
                }
            }
            if ($scope.vm.IsWizard) {
                $scope.vm.formFields.forEach(function(e) {
                    if (e.name != fk) {
                        e.expanded = false;
                    }
                });
            }
            if (fk == 'source') {  // crutch
                setTimeout(function() {
                    var sellerId = $scope.$root.safeChain($scope.vm.formData,'source, seller, value');
                    if (sellerId) {
                        document.getElementById('source--seller').value = $scope.vm.formData.source.seller.value;
                    }
                }, 10);
            }
        });


        // + kinda wizzard ---------------------------------------------------------------------------------------------------------------------------

        $scope.wizard = {};

        // ---

        $scope.wizard.init = function() {
            $scope.wizard.next = 'source';
            $scope.wizard.folds = [];
            $scope.vm.formFields.forEach(function(e) {
                if (e.type == 'group') {
                    $scope.wizard.folds.push({
                        name: e.name,
                        visited:  false,
                        passed: false
                    });
                }
            });

            var s = $scope.$root.getField($scope.vm.formFields, ['source', 'seller']);
            if (/\d+/.test(s.default)) {
                $scope.vm.formData.source.seller.value = s.default;
            }

            if ($scope.vm.formData.source.seller.value) {
                $scope.wizard.getFold('source').visited = true;
                $scope.$root.getField($scope.vm.formFields,['source'])['c-logic'] = [
                    { path: 'tab', operator: '!=', value: 'gift', relation: 'or'}
                ];
                setTimeout(function() {
                    angular.element('[field-key="source"]').hide();
                }, 1000);
            }
            $scope.vm.formSettings.hideSubmit = true;
            $scope.wizard.setFold('pies');
        };

        // ---

        $scope.wizard.getFold = function(name) {
            return $scope.wizard.folds.find(function(f) {
                return f.name == name;
            });
        };

        // ---

        $scope.wizard.canLeave = function(name) {
            var message = '';
            if ((name == 'source') && !$scope.wizard.sellerSelected()) {
                message = 'seller';
            } else if ((name == 'site') && !$scope.wizard.siteOk()) {
                message = 'pickup location';
            } else if ((name == 'donation') && !$scope.wizard.cartNotEmpty()) {
                message = 'donation, pies or gifts';
            }
            if (message != '') {
                $scope.$root.errorMessage = 'Please select a ' + message;
                $scope.$root.openModal("error-modal");
                return false;
            } else {
                return true;
            }
        };

        // ---

        $scope.wizard.prophecy = function(current) {
            // console.log('tab--',$scope.vm.formData.tab);
            $scope.wizard.getFold(current).passed = false;
            var path = $scope.wizard.folds.filter(function(e) {
                return (!e.passed || !e.visited) && !(e.name == 'gift-pies' && $scope.vm.formData.tab.value != 'gift') && !(e.name == 'pies' && $scope.vm.formData.tab.value == 'gift') ;
            });
            // console.log(path);
            var currentIdx = path.findIndex(function(e) {
                return e.name == current;
            });
            // console.log('current_idx', currentIdx);

            var next = path[currentIdx + 1].name;
            if (next == 'site' && $scope.wizard.siteOk()) {
                next = path[currentIdx + 2].name;
            } else if (next == 'source') {
                if ($scope.wizard.sellerSelected()) {
                    next = path[currentIdx + 2].name;
                } else if ($scope.vm.formData.tab.value == 'redeem') {
                    next = $scope.wizard.siteOk() ? 'donation' : 'site';
                }
            }
            return next;
        };

        // ---

        $scope.wizard.setButton = function(fold) {
            var field = $scope.$root.getField($scope.vm.formFields, [fold]);
            if (!field.has_step_button) {
                return;
            }
            var nextFold = $scope.wizard.prophecy(fold);
            if (nextFold) {
                $scope.wizard.next = nextFold;
                field.has_step_button = $scope.$root.getField($scope.vm.formFields, [nextFold]).navigation_label;
                $scope.$evalAsync();
            }
        };

        //  ---

        $scope.wizard.sellerSelected = function() {
            return ($scope.$root.safeChain($scope.vm.formData,'source, seller-direct, value') == 'direct') || $scope.vm.formData.source.seller.value;
        };

        // ---

        $scope.wizard.siteOk = function() {
            if (!$scope.$root.safeChain($scope.vm.formData, 'site, pickup-location, value') && (Object.values($scope.vm.sidebarData.pies).find(function(e) {
                    return !e.virtual;
                }))) {
                return false;
            } else {
                return true;
            }
        };

        // ---

        $scope.wizard.cartNotEmpty = function() {
            return (Object.keys($scope.vm.sidebarData.pies).length > 0) || ($scope.vm.sidebarData.donation > 0) || ($scope.vm.sidebarData.giftTotal > 0);
        };

        // ---

        $scope.wizard.setFold = function(fold) {
            if (fold != 'gift-pies' && $scope.vm.formData.tab.value == 'gift') {
                $scope.setTab('self');
                return;
            }
            var fieldTo = $scope.$root.getField($scope.vm.formFields, [fold]);
            // console.log('fold:', fold);
            // console.log('to:',fieldTo);
            $scope.openFold(fieldTo);
            $scope.wizard.getFold(fold).visited = true;

            if (fold == 'gift-pies') {
                fieldTo['c-logic'] = [
                    { path: 'tab', operator: '==', value: 'gift', relation: 'or'}
                ];
            } else {
                fieldTo['c-logic'] = [
                    { path: 'tab', operator: '!=', value: 'gift', relation: 'or'}
                ];
            }

            if ((fold == 'site' || fold == 'donation') && $scope.vm.formData.tab.value == 'redeem') {
                $scope.$root.getField($scope.vm.formFields, ['source'])['c-logic'] = [
                    { path: 'tab', operator: '!=', value: 'gift', relation: 'or'}
                ];
            }

            $scope.wizard.setButton(fold);

            if (fold == 'billing') {
                setTimeout(function() {
                    $scope.checkCoupon();
                }, 500);
                $scope.vm.formSettings.hideSubmit = false;
            }

            if ((fold == 'pies' && !$scope.wizard.allow_scroll_to_pies) || fold == 'gift-pies') {
                return;
            }

            if ($scope.$root.rsp.apn.chk) {
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('.form-field[field-key="' + fold + '"] .content').parent().offset().top - 185
                    }, 1);
                }, 100);
            } else {
                setTimeout(function() {
                    var el = $('.form-field[field-key="' + fold + '"] .content');
                    if (el.length != 0) {
                        $('html, body').animate({
                            scrollTop: el.parent().offset().top - 84
                        }, 500);
                    }
                }, 500);
            }
        };

        // ---

        $scope.$on('next-fold', function(e, t) {
            if (!$scope.wizard.canLeave(t.from)) {
                return;
            }
            $scope.wizard.getFold(t.from).passed = true;
            $scope.wizard.setFold($scope.wizard.next);
        });

        // - kinda wizzard ---------------------------------------------------------------------------------------------------------------------------------

        $scope.$on('pie-changed', function(e, id) {
            var p = $scope.vm.formData.pies.find(function(e) {
                return (e.pie.id == id) && (e.pie.value > 0);
            });
            if (!p && ($scope.vm.formData.donation.pie.value > 0)) {
                p = $scope.vm.formData.donation;
            }

            if (p) {
                if (angular.isUndefined($scope.vm.formData.cartPies[id])) {
                    $scope.vm.formData.cartPies[id] = 0;
                }
                $scope.vm.formData.cartPies[id] += p.pie.value;
                if (angular.isDefined($scope.vm.sidebarData.pies[id])) {
                    $scope.vm.sidebarData.pies[id].value += p.pie.value;
                } else {
                    $scope.vm.sidebarData.pies[id] = angular.copy(p.pie);
                }
                $scope.recalc();
                p.pie.value = 1;
            }
        });

        $scope.$on('location-changed', function(e,loc) {
            $scope.vm.sidebarData.location = loc;
            $scope.vm.sidebarData.location.ranges = loc.dt ?  $scope.makeRanges(loc.hoursRaw) : null;
            $scope.vm.sidebarData.location.rangeDate = loc.dt ? $sce.trustAsHtml(dateFilter(new Date(loc.hoursRaw[0]['time-from'] * 1000),'EEEE, MMMM d')) : null;
            $scope.vm.sidebarData.location.range = '';
            $scope.vm.formData.dtRange = '';
            $scope.vm.formData.site['pickup-location'].value = loc.id;
            $scope.$root.$broadcast('pickup-location-changed-external', false);
            if ($scope.$root.rsp.apn.chk) {
                $scope.$root.openModal("info-modal");
            }

            if ($scope.$root.project_has_opt('reservation')) {
                $scope.reserve();
            }

            if ($scope.$root.project_has_opt('privSiteCode')) {
                if (loc.site_code) {
                    $scope.vm.formData.site.site_code = loc.site_code;
                }
            }

        });
        $scope.makeRanges = function(hours) {
            var ranges = [];
            hours.forEach(function(r) {
                ranges.push({
                    // value: r['time-from'].value + '|' + r['time-to'].value,
                    // title: dateFilter(new Date(r['time-from'].value * 1000), 'h:mm a') + ' - ' + dateFilter(new Date(r['time-to'].value * 1000), 'h:mm a')
                    value: r['time-from'] + '|' + r['time-to'],
                    title: dateFilter(new Date(r['time-from'] * 1000), 'h:mm a') + ' - ' + dateFilter(new Date(r['time-to'] * 1000), 'h:mm a')
                });
            });
            return ranges;
        };

        $scope.$watch('vm.formData.source["seller-direct"].value', function (value) {
            if (value == 'direct') {
                $scope.vm.sidebarData.sellerName = '';
            }
        });

        $scope.$watch('vm.formData.source.seller.value', function (value) {
            $scope.setSeller(value);
        }, true);

        $scope.setSeller = function(value) {
            if (!value) {
                return;
            }

            var sellerField = $scope.$root.getField($scope.vm.formFields, ['source', 'seller']);
            if (sellerField) {
                var seller =  sellerField.choices.find(function(e) {
                    return e.value == value;
                });

                $scope.vm.sidebarData.sellerName = $scope.nameFirst(seller.title);
                if ($scope.$root.project_has_opt('privSite')) {
                    $http.post(ajaxurl, {
                        action: 'pie_action',
                        method: 'get_private_site',
                        nonce: $scope.$root.stats.nonce,
                        params: {
                            seller_id: seller.value
                        }
                    }).then(function(response) {
                        var locId = 0;
                        if (response.data.result) {
                            response.data.payload.location.hours = $scope.$root.formatHours(response.data.payload.location.hours);
                            $scope.vm.sidebarData.location = response.data.payload.location;
                            locId = response.data.payload.location.id;
                            $scope.vm.formData.site['pickup-location'].value = locId;
                        } else {
                            $scope.vm.sidebarData.location = null;
                            $scope.vm.formData.site['pickup-location'].value = null;
                        }
                        $scope.$root.$broadcast('pickup-location-changed-external', true);
                    });
                }
            }
        };

        var tp;
        $scope.$watch('vm.formData.donation.amount.value', function (value) {
            if (angular.isDefined(value)) {
                $scope.vm.sidebarData.donation = parseInt(value);
                $timeout.cancel(tp);
                tp = $timeout(function() {
                    $scope.recalc();
                }, 1000);
            }
        });

        $scope.recalc = function() {
            var orderTotal = {
                regular: 0,
                deluxe: 0
            };
            var discountableAmount = 0;
            var discountableCount = 0;
            for (var k in $scope.vm.sidebarData.pies) {
                var pname = $scope.vm.sidebarData.pies[k].name.toLowerCase();
                var totalsKey = '';

                if (pname.indexOf('deluxe') != -1) {
                    totalsKey = 'deluxe';
                } else {
                    totalsKey = 'regular';
                }
                orderTotal[totalsKey] += $scope.vm.sidebarData.pies[k].value * $scope.vm.sidebarData.pies[k].price;
                if (!$scope.vm.sidebarData.pies[k].virtual) {
                    discountableAmount += $scope.vm.sidebarData.pies[k].value * $scope.vm.sidebarData.pies[k].price;
                    discountableCount += $scope.vm.sidebarData.pies[k].value;
                }
            }
            $scope.vm.sidebarData.orderTotal = orderTotal.regular + orderTotal.deluxe;

            $scope.vm.sidebarData.giftTotal = 0;
            for (var g in $scope.vm.sidebarData.giftPies) {
                // $scope.vm.sidebarData.giftTotal +=  $scope.vm.sidebarData.giftPies[g].quantity.value * $scope.vm.regularPrice;
                $scope.vm.sidebarData.giftTotal +=  $scope.vm.sidebarData.giftPies[g].quantity.value * $scope.vm.giftPrice;
            }
            var constantPrice = $scope.vm.sidebarData.donation + $scope.vm.sidebarData.giftTotal + orderTotal.deluxe;
            $scope.vm.sidebarData.total = orderTotal.regular + constantPrice;

            if ($scope.$root.project_has_opt('giftPie')) {
                // var discount = $scope.vm.sidebarData.couponData.quantity * $scope.vm.regularPrice;
                var discount = $scope.vm.sidebarData.couponData.quantity * $scope.vm.giftPrice;
                if(Object.getOwnPropertyNames($scope.vm.sidebarData.couponData).length) {
                    $scope.vm.sidebarData.couponTotal = constantPrice + orderTotal.regular - Math.min(orderTotal.regular, discount);
                }
                if (Object.getOwnPropertyNames($scope.vm.sidebarData.couponData).length  && (orderTotal.deluxe != 0)) {
                    $scope.vm.sidebarData.warning = true;
                } else {
                    $scope.vm.sidebarData.warning = false;
                }
            }

            var piesA = $scope.$root.isEmptyObject($scope.vm.sidebarData.pies) ? [] :  Object.values($scope.vm.sidebarData.pies);
            $scope.vm.virtualCount = 0;
            $scope.vm.realCount = 0;
            piesA.forEach(function(e) {
                if (e.virtual) {
                    $scope.vm.virtualCount += e.value;
                } else {
                    $scope.vm.realCount += e.value;
                }
            });

            var siteGroup = $scope.$root.getField($scope.vm.formFields, ['site']);
            var disindex = siteGroup.classes.indexOf('disabled');

            if ($scope.vm.realCount == 0) {
                if (disindex == -1) {
                    var fold = angular.element('[field-key="pies"]');
                    if (fold.find('.content.active').length == 0) {
                        fold.find('button.accordion-toggle').click();
                        siteGroup.expanded = false;
                    }

                    siteGroup.classes.push('disabled');
                    $scope.vm.sidebarData.location = null;
                    if ($scope.$root.checkChain($scope.vm.formData, 'site,pickup-location')) {
                        $scope.vm.formData.site['pickup-location'].value = 0;
                    }
                }
                // --
                if ($scope.vm.IsWizard) {
                    var exp1 = $scope.vm.formFields.find(function(e) {
                        return e.expanded;
                    }).name;
                    $scope.wizard.setButton(exp1);
                }
                // --
            } else {
                siteGroup.classes.splice(disindex, 1);
                if ($scope.vm.IsWizard) {
                    var exp = $scope.vm.formFields.find(function(e) {
                        return e.expanded;
                    }).name;
                    $scope.wizard.setButton(exp);
                }
            }

            if($scope.$root.project_has_opt('pieInventory')) {
                var needRecalc = false;
                for (var kk in $scope.vm.sidebarData.pies) {
                    if ($scope.vm.sidebarData.pies[kk].inventory && $scope.vm.sidebarData.pies[kk].inventory) {
                        if ($scope.vm.sidebarData.pies[kk].left < $scope.vm.sidebarData.pies[kk].value) {
                            $scope.vm.sidebarData.pies[kk].value = $scope.vm.sidebarData.pies[kk].left;
                            $scope.vm.formData.cartPies[kk] = $scope.vm.sidebarData.pies[kk].left;
                            needRecalc = true;
                        }
                    }
                }
                if (needRecalc) {
                    $scope.recalc();
                }
            }
            if ($scope.vm.sidebarData.discountData && !$scope.vm.sidebarData.discountData.invalid) {
                var constantTotal = $scope.vm.sidebarData.total - discountableAmount;
                if ($scope.vm.sidebarData.discountData.discount_type == 'totalAmount') {
                    $scope.vm.sidebarData.discountAmount = $scope.vm.sidebarData.discountData.discount_value;
                } else if ($scope.vm.sidebarData.discountData.discount_type == 'percent') {
                    $scope.vm.sidebarData.discountAmount = ($scope.vm.sidebarData.discountData.discount_value / 100) * discountableAmount;
                } else {
                    $scope.vm.sidebarData.discountAmount = ($scope.vm.sidebarData.discountData.discount_value * discountableCount);
                }

                $scope.vm.sidebarData.discountTotal = constantTotal + Math.max(discountableAmount - $scope.vm.sidebarData.discountAmount, 0);

            }

            var finalTotal = Math.min(
                $scope.vm.sidebarData.total,
                (!$scope.$root.isEmptyObject($scope.vm.sidebarData.discountData)  ?  $scope.vm.sidebarData.discountTotal : 99999999),
                (!$scope.$root.isEmptyObject($scope.vm.sidebarData.couponData) ?  $scope.vm.sidebarData.couponTotal : 99999999)
            );

            if ($scope.$root.project_has_opt('creditCardFee')) {
                var feeValue = $scope.$root.safeChain($scope.vm.formData.billing, 'fee_value,value', 10);
                var cardFee = $scope.$root.safeChain($scope.vm.formData.billing, 'card_fee,value', false);
                $scope.vm.sidebarData.card_fee = (finalTotal * feeValue / 100) * cardFee;
                finalTotal += (finalTotal * feeValue / 100) * cardFee;

                if ($scope.vm.sidebarData.discountData.invalid) {
                    $scope.vm.sidebarData.discountData = {};
                }

                if (!$scope.$root.isEmptyObject($scope.vm.sidebarData.discountData)) {
                    $scope.vm.sidebarData.discountTotal = finalTotal;
                } else {
                    $scope.vm.sidebarData.total = finalTotal;
                }
            }

            if (finalTotal == 0) {
                $scope.showPayment(false);
            } else {
                $scope.showPayment(true);
            }

            window.cartTotal = finalTotal;

            $scope.$broadcast('site-inventory-filter', $scope.vm.sidebarData.pies);

            if ($scope.$root.project_has_opt('layoutCS')) {
                var prevCount = $scope.vm.sidebarData.totalCount;
                var piesCount = Object.keys($scope.vm.sidebarData.pies).reduce(function(total, k) {
                    var pieInCartElement  = document.querySelector('#pie-in-cart-' + k + ' div');
                    if (pieInCartElement) {
                        pieInCartElement.innerText = $scope.vm.sidebarData.pies[k].value + ' in cart';
                    }
                    return total + $scope.vm.sidebarData.pies[k].value;
                }, 0);

                var giftCount = $scope.vm.sidebarData.giftPies.reduce(function(total, e) {
                    return total + parseInt(e.quantity.value);
                }, 0);

                $scope.vm.sidebarData.totalCount = piesCount + giftCount + ($scope.vm.sidebarData.donation !== 0 ? 1 : 0);

                if (prevCount < $scope.vm.sidebarData.totalCount) {
                    $scope.$root.openModal("info-modal");
                }
            }

            if ($scope.$root.project_has_opt('reservation')) {
                $scope.reserve();
            }

            if ($scope.$root.project_has_opt('dedication')) {
                var dfield = $scope.$root.getField($scope.vm.formFields, ['dedication']);
                if ($scope.vm.virtualCount > 0) {
                    dfield['c-logic'] = [];
                } else {
                    dfield['c-logic'] = [{ path: 'no-path',operator: '==', value: 'no-val', relation: 'or'}];
                }
                var rfield = $scope.$root.getField($scope.vm.formFields, ['dedication', 'recipients']);
                rfield.max = $scope.vm.virtualCount;
            }
            if ($scope.$root.rsp.apn.chk && !($scope.vm.sidebarData.sellerName || $scope.vm.sidebarData.orderTotal || $scope.vm.sidebarData.location || $scope.vm.sidebarData.donation)) {
                $scope.vm.sidebarOpen();
            }
        };

        $scope.checkReservation = function() {
            var reservationCookieName = 'pie-reservation-id';
            var rId = $cookies.get(reservationCookieName);
            if (rId) {
                $scope.vm.bypassReservation = true;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: 'check_reservation',
                    nonce: $scope.$root.stats.nonce,
                    params: {
                        id: rId
                    }
                }).then(function(response) {
                    if (response.data.result) {
                        // console.log(response.data.payload);
                        // $scope.vm.sidebarData.reservationId = response.data.payload.id;
                        $scope.vm.sidebarData.pies = response.data.payload.pies;
                        if (response.data.payload.location) {
                            $scope.vm.sidebarData.location = response.data.payload.location;
                            // $scope.vm.formData.site['pickup-location'].value = response.data.payload.location.id;
                            $scope.vm.formData.site = {'pickup-location': {value : response.data.payload.location.id}};
                        }
                        $scope.recalc();
                        Object.values(response.data.payload.pies).forEach(function(e) {
                            $scope.vm.formData.cartPies[e.id] = e.value;
                        });
                    } else {
                        $cookies.remove(reservationCookieName);
                        $scope.vm.bypassReservation = false;
                    }
                });
            }
        };
        $scope.setReservationCookie = function(id) {
            var expDate = new Date();
            expDate = new Date(expDate.getTime() + 900000);
            $cookies.put('pie-reservation-id', id, {
                path: '/',
                secure: true,
                samesite: 'Strict',
                expires: expDate
            });
        };

        $scope.reserve = function() {
            if ($scope.vm.bypassReservation) {
                $scope.vm.bypassReservation = false;
                return;
            }
            var reservationCookieName = 'pie-reservation-id';
            var rId = $cookies.get(reservationCookieName) || 0;
            if ((rId == 0) &&  $scope.$root.isEmptyObject($scope.vm.sidebarData.pies)) {
                return;
            }
            var pies = {};
            Object.values($scope.vm.sidebarData.pies).forEach(function(e) {
                if (!e.virtual && !e.gift) {
                    pies[e.id] = e.value;
                }
            });
            if (Object.keys(pies).length == 0) {
                return;
            }
            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'reserve',
                nonce: $scope.$root.stats.nonce,
                params: {
                    id: rId,
                    pies: pies,
                    location_id: $scope.$root.safeChain($scope.vm.sidebarData,'location,id') || 0
                }
            }).then(function(response) {

                if (response.data.payload.id != 0) {
                    if ((rId == 0) || (rId != response.data.payload.id)) {
                        $scope.setReservationCookie(response.data.payload.id);
                    }
                } else {
                    $cookies.remove(reservationCookieName);
                }
                if (!response.data.result) {
                    var preserve = $scope.vm.sidebarData.location !=  null;
                    if (preserve) {
                        $scope.vm.sidebarData.location = null;
                    }
                    if (response.data.payload && response.data.payload.limit) {
                        for(var iId in $scope.vm.sidebarData.pies) {
                            if (response.data.payload.limit[iId]) {
                                $scope.vm.sidebarData.pies[iId].value = response.data.payload.limit[iId];
                                $scope.vm.formData.cartPies[iId] = response.data.payload.limit[iId];
                            } else {
                                if (!$scope.vm.sidebarData.pies[iId].virtual && !$scope.vm.sidebarData.pies[iId].virtual && !preserve) {
                                    delete $scope.vm.sidebarData.pies[iId];
                                    delete $scope.vm.formData.cartPies[iId];
                                }
                            }
                        }
                        // console.log($scope.vm.sidebarData.pies);
                        $scope.vm.bypassReservation = true;
                        $scope.recalc();
                    }
                    if (response.data.message) {
                        $scope.$root.errorMessage = response.data.message;
                        $scope.$root.openModal("error-modal");
                    }
                }
                // $cookies.remove(reservationCookieName);
            });
        };

        $scope.showPayment = function(show) {
            if (show) {
                angular.element('#cardholder.ng-untouched').addClass('ng-invalid');
                angular.element('[field-key="credit-card"]').show();
                angular.element('[field-key="payment_method"]').show();
                angular.element('[field-key="wallet"]').show();
            } else {
                if ($scope.$root.project_has_opt('layoutCS')) {
                    // var pm = $scope.vm.formData.billing.payment_method;
                    var pm = $scope.$root.safeChain($scope.vm.formData, 'billing, payment_method');
                    if (pm) {
                        if (pm.value == 'wallet') {
                            pm.value = 'card';
                        }
                        setTimeout(function() {
                            angular.element('#cardholder').removeClass('ng-invalid');
                            angular.element('[field-key="credit-card"]').hide();
                            angular.element('[field-key="payment_method"]').hide();
                            angular.element('[field-key="wallet"]').hide();
                        }, 500);
                    }
                } else {
                    angular.element('#cardholder').removeClass('ng-invalid');
                    angular.element('[field-key="credit-card"]').hide();
                    angular.element('[field-key="payment_method"]').hide();
                    angular.element('[field-key="wallet"]').hide();
                }
            }
        };

        $scope.removePie = function(id) {
            if ($scope.$root.project_has_opt('layoutCS')) {
                var pic = document.querySelector('#pie-in-cart-' + id + ' div');
                if (pic) {
                    pic.innerText = '';
                }
            }
            delete $scope.vm.sidebarData.pies[id];
            delete $scope.vm.formData.cartPies[id];
            $scope.recalc();
        };

        $scope.removeGiftPie = function(idx) {
            $scope.vm.sidebarData.giftPies.splice(idx,1);
            $timeout(function() {
                var db = angular.element.find('[field-key="gift-pies"] .group-content-wrap .repeater:eq(' + idx + ') a.del-row-btn');
                if (db.length) {
                    db[0].click();
                }
            }, 0, false);
            $scope.recalc();
        };

        // ---

        $scope.setTab = function(tab) {
            if (tab == 'donate') {
                $location.url('/donate/');
                return;
            }
            if (!$scope.vm.formData.tab) {
                $scope.vm.formData.tab = {};
            }
            $scope.vm.formData.tab.value = tab;
            var g = $scope.$root.safeChain($scope.vm.formSettings, 'tabs, ' + tab + ', group');
            if (g) {
                for (var gn in g) {
                    var f = $scope.$root.getField($scope.vm.formFields,[gn]);
                    f.help = '';
                    f.info = g[gn];
                }
            }
            $scope.$evalAsync();
            if ($scope.vm.IsWizard) {
                if (tab == 'gift') {
                    $scope.vm.formSettings.hideSubmit = true;
                    $scope.wizard.setFold('gift-pies');
                } else {
                    var pies = $scope.wizard.getFold('pies');
                    pies.visited = false;
                    pies.passed = false;
                    var next = tab == 'redeem' ? 'pies' : ($scope.wizard.cartNotEmpty() ?  $scope.wizard.prophecy('pies') : 'pies');

                    if (next == 'pies') {
                        $scope.wizard.allow_scroll_to_pies = true;
                    }

                    $scope.wizard.setFold(next);
                    // console.log(' set tab next', next);
                }
                return;
            }

            $scope.$broadcast('accordion-toggle', (tab == 'gift' ? 'gift-pies' : 'pies'));
        };

        //  ---

        $scope.switchTab = function(e) {
            $scope.setTab(e.target.dataset.tab);
        };

        $scope.checkCoupon = function(auto) {
            var cCode = $scope.$root.safeChain($scope.vm.formData.billing, 'coupon-code,value');

            if (!cCode) {
                cCode = $scope.$root.getField($scope.vm.formFields, ['billing', 'coupon-code']).default;
            }
            // console.log('cCode',cCode);
            if ((cCode) /*&& (cCode !== $scope.vm.sidebarData.couponCode) */ && !$scope.vm.doingRequest) {
                $scope.vm.sidebarData.couponCode = cCode;
                $scope.vm.doingRequest = true;
                // console.log('before-post');
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: 'check_coupon',
                    nonce: $scope.$root.stats.nonce,
                    params: {
                        code: $scope.vm.sidebarData.couponCode
                    }
                }).then(function(response) {
                    $scope.vm.doingRequest = false;
                    if (response.data.result) {
                        $scope.vm.sidebarData.couponData = response.data.payload;
                        if (!$scope.vm.formData.billing) {
                            $scope.vm.formData.billing = {payment_method: {value: 'wallet'}};
                        }

                        var sellerId = parseInt(response.data.payload.seller_id);
                        $scope.vm.formData.source = {
                            'seller-direct' : {
                                value: sellerId == 0 ? 'direct' : 'seller'
                            },
                            seller: {
                                value: sellerId
                            }
                        };

                        $scope.vm.formData.billing['first-name'] = {value: $scope.vm.sidebarData.couponData.first_name};
                        $scope.vm.formData.billing['last-name'] = {value: $scope.vm.sidebarData.couponData.last_name};
                        $scope.vm.formData.billing.email = {value: $scope.vm.sidebarData.couponData.email};
                        angular.element('[field-key="apply-coupon"] button').parent().html('<div class="coupon-applied">Coupon Applied</div>');
                        angular.element('[field-key="source"]').hide(10, function() {
                            angular.element(this).remove();
                        });

                        angular.element('input[name="coupon-code"]').siblings('ul.error-msg').hide().find('li').text('');
                        $scope.recalc();
                        if ($scope.vm.IsWizard) {
                            $scope.wizard.setButton('pies');
                        }
                    } else {
                        $scope.vm.sidebarData.couponData = {};
                        $scope.vm.sidebarData.couponData.invalid = true;
                        angular.element('input[name="coupon-code"]').siblings('ul.error-msg').show().find('li').show().text(response.data.message);
                    }
                });
            }
        };

        $scope.$on('add-gift', function(e) {
            angular.element('[field-key="gift-pies"] .qty-error').remove();
            $scope.vm.sidebarData.giftPies = $scope.vm.formData['gift-pies'].filter(function(el,idx) {
                if (parseInt(el.quantity.value) <= 0 || !el['first-name'].value || !el['last-name'].value || !el.email.value) {
                    angular.element('[field-key="gift-pies"] [fields="fieldSet"]:eq(' + idx + ')').append('<span class="form-error">All fields are required</span>');
                    setTimeout(function() {
                        angular.element('span.form-error').remove();
                    }, 5000);
                } else {
                    return true;
                }

            });
            $scope.vm.formData.cartGiftPies = $scope.vm.sidebarData.giftPies;
            $scope.recalc();
        });

        $scope.$on('check-coupon', function(e) {
            // console.log('on-check-coupon');
            $scope.checkCoupon(false);
        });

        $scope.$on('submit-modal-opened', function(e) {
            for(var u in $scope.vm.sidebarData.pies) {
                $scope.vm.sidebarData.pies[u].value = $scope.vm.formData.cartPies[u];
            }
            var sbd = Object.assign({}, $scope.vm.sidebarData);
            if ($scope.vm.sidebarData.location && $scope.vm.sidebarData.location.range) {
                var ft = sbd.location.range.split('|');
                sbd.location.rangeStr = $sce.trustAsHtml(dateFilter(new Date(ft[0] * 1000),'EEEE, MMMM d') + '<br>' + dateFilter(new Date(ft[0] * 1000),'h:mm a') + ' - ' + dateFilter(new Date(ft[1] * 1000),'h:mm a'));
                sbd.location.rangeDate = $sce.trustAsHtml(dateFilter(new Date(ft[0] * 1000),'EEEE, MMMM d'));
            }
            // $scope.$root.$broadcast('sidebar-data', [sbd, $scope.vm.regularPrice]);
            $scope.$root.$broadcast('sidebar-data', [sbd, $scope.vm.giftPrice]);
        });

        $scope.editPies = function() {
            $scope.vm.piesEditing = !$scope.vm.piesEditing;
            for(var u in $scope.vm.sidebarData.pies) {
                $scope.vm.formData.cartPies[u] = $scope.vm.sidebarData.pies[u].value;
            }
            if (!$scope.vm.piesEditing) {
                $scope.recalc();
            }
        };

        $scope.nameFirst = function(secondFirst) {
            var s = secondFirst.split(/\s*,\s*/);
            if (s.length == 2) {
                return s[1] + ' ' + s[0];
            } else {
                return secondFirst;
            }
        };

        $scope.dtRangeChanged = function() {
            setTimeout(function() {
                $scope.vm.formData.dtRange =  $scope.vm.sidebarData.location.range;
            }, 1);
        };
        // + org discount
        $scope.$on('check_discount', function(e) {
            $scope.checkDiscount();
        });
        $scope.checkDiscount = function() {
            if ($scope.$root.checkChain($scope.vm.formData.billing,'discount_code,value') &&
                !$scope.vm.doingRequest
            ) {
                $scope.vm.sidebarData.discountCode = $scope.vm.formData.billing.discount_code.value;
                // var hasVirtual = false;
                var hasReal = false;
                if ($scope.vm.sidebarData.pies) {
                    for (var i in $scope.vm.sidebarData.pies) {
                        if (!$scope.vm.sidebarData.pies[i].virtual) {
                            hasReal = true;
                            break;
                        }
                    }
                }

                if (!hasReal) {
                    var df = angular.element('input[name="discount_code"]');
                    df.siblings('ul.error-msg').show().find('li').show().text('Discount codes can only be applied to the regular pies’ prices');
                    df.val('');
                    df.trigger('change');
                    return;
                }
                $scope.vm.doingRequest = true;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: 'check_discount',
                    nonce: $scope.$root.stats.nonce,
                    params: {
                        code: $scope.vm.sidebarData.discountCode
                    }
                }).then(function(response) {
                    $scope.vm.doingRequest = false;
                    // console.log('rdata',response.data);
                    if (response.data.result) {
                        $scope.vm.sidebarData.discountData = response.data.payload;
                        angular.element('[field-key="apply_discount"] button').parent().html('<div class="coupon-applied">Discount Applied</div>');
                        angular.element('input[name="discount_code"]').siblings('ul.error-msg').hide().find('li').text('');
                        $scope.recalc();
                    } else {
                        $scope.vm.sidebarData.discountData = {};
                        // $scope.vm.sidebarData.discountData.invalid = true;
                        angular.element('input[name="discount_code"]').siblings('ul.error-msg').show().find('li').show().text(response.data.message);
                        angular.element('input[name="discount_code"]').val('');
                        angular.element('input[name="discount_code"]').trigger('change');
                        // $scope.recalc();
                    }
                });
            }
        };

        // - org discount

        if ($scope.$root.project_has_opt('dedication')) {
            $scope.$watch('vm.formData.dedication.recipients.length', function(newLen, oldLen) {
                if ((newLen > 1) && (newLen > oldLen)) {
                    var isCopy = $scope.$root.safeChain($scope.vm.formData, 'dedication,recipients, 0, copy, value');
                    if (isCopy) {
                        var source  = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, 0, message, value');
                        var target = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, ' + (newLen - 1) + ', message');
                        target.value = source;
                    }
                    angular.element('[parent-path="dedication,recipients,' + (newLen - 1) + '"][field-key="copy"]').hide();
                }
            }, true);

            $scope.$watch('vm.formData.dedication.recipients[0].copy.value', function(newVal, oldVal) {
                if (!oldVal && newVal) {
                    var source  = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, 0, message, value');
                    var len = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients').length;
                    for(var i = 1; i < len; i++) {
                        $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, ' + i + ', message').value = source;
                    }
                }
            });
        }

        $scope.removeDonation = function() {
            $scope.vm.sidebarData.donation = 0;
            $scope.vm.formData.donation.amount.value = 0;
        };

        if ($scope.$root.project_has_opt('creditCardFee')) {
            $scope.$watch('vm.formData.billing.card_fee.value', function(v) {
                if ($scope.vm.recalc_ok) {
                    $scope.recalc();
                }
                $scope.vm.recalc_ok = true;
            });
        }
    }
})();